var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotification = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M20 18.5c0 .275-.225.5-.5.5h-15a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h15c.275 0 .5.225.5.5zM12 21a1.5 1.5 0 0 1-1.415-1h2.829c-.206.582-.762 1-1.414 1M6 11c0-3.309 2.691-6 6-6s6 2.691 6 6v5H6zm13.5 5H19v-5c0-3.69-2.874-6.717-6.5-6.975V2.5a.5.5 0 0 0-1 0v1.525C7.874 4.283 5 7.31 5 11v5h-.5c-.827 0-1.5.673-1.5 1.5v1c0 .827.673 1.5 1.5 1.5h5.051c.232 1.14 1.242 2 2.449 2 1.208 0 2.217-.86 2.449-2H19.5c.827 0 1.5-.673 1.5-1.5v-1c0-.827-.673-1.5-1.5-1.5M11 7c-1.654 0-3 1.346-3 3a.5.5 0 0 0 1 0c0-1.103.897-2 2-2a.5.5 0 0 0 0-1",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotification);
export default ForwardRef;